import React from 'react';
import { Pagination, Table, Empty } from 'antd';
import { useIsMobile } from '@src/packages/utils';
import IntlMessages from 'util/IntlMessages';
import styles from './styles.module.less';

const UsersTable = ({
  columns = [],
  data = [],
  usersSelected = [],
  handleUsers,
  loading,
  pagination,
}) => {
  const { isMobile } = useIsMobile();
  const rowSelection = {
    selectedRowKeys: usersSelected,
    onChange: handleUsers,
    columnWidth: 40,
    fixed: isMobile ? 'left' : undefined,
  };

  const ROW_HEIGHT = 38;
  const HEADER_HEIGHT = 38;
  const PAGINATION_HEIGHT = 36;
  const CONTAINER_PADDING = 12;
  const FIXED_DISPLAY_ROWS = 5;
  const maxVisibleRows = data.length < 10 ? 5 : 8;

  const getVisibleBodyRows = rowCount => {
    if (rowCount <= FIXED_DISPLAY_ROWS) {
      return FIXED_DISPLAY_ROWS;
    }
    return Math.min(rowCount, maxVisibleRows);
  };

  const visibleBodyRows = getVisibleBodyRows(data.length);
  const containerHeight =
    HEADER_HEIGHT + visibleBodyRows * ROW_HEIGHT + CONTAINER_PADDING + PAGINATION_HEIGHT;
  const tableScrollHeight = visibleBodyRows * ROW_HEIGHT;

  // Show empty state when no data and not loading
  if (data.length === 0 && !loading) {
    return (
      <div className={styles.usersTableEmpty}>
        <Empty description={<IntlMessages id="timeTracker.groupUsersTable.emptyState" />} />
      </div>
    );
  }

  return (
    <div
      data-testid="users-table"
      className={`${styles.usersTable} users-table-host`}
      style={{
        height: `${containerHeight}px`,
        '--users-table-body-height': `${tableScrollHeight}px`,
        '--users-table-header-height': `${HEADER_HEIGHT}px`,
      }}
    >
      <Table
        className={styles.usersTableWrapper}
        size="small"
        rowKey="id"
        rowSelection={rowSelection}
        columns={columns}
        dataSource={data}
        loading={loading}
        pagination={false}
        scroll={{ y: tableScrollHeight, x: isMobile ? 400 : 'max-content' }}
      />
      <div className={styles.usersTablePagination}>
        <Pagination {...pagination} size="small" />
      </div>
    </div>
  );
};

export default React.memo(UsersTable);
